import ar_white from "../../../assets/images/Introduction/ar_white.svg";
import home_white from "../../../assets/images/Introduction/home_white.svg";
import ct_mobi from "../../../assets/images/Contact-us/ct_mobi.webp";

export default function ContactBanner() {
  return (
    <div className="w-full">
      <div className="w-full">
        <div
          className="block md:hidden lg:hidden w-full relative bg-center bg-cover bg-no-repeat"
          style={{
            backgroundImage: `url(${ct_mobi})`,
          }}
        >
          <div className="w-full ">
            <div className="w-full mx-auto flex flex-col gap-2 items-center justify-center pt-16 py-[20px] px-[20px]">
              <div className="w-full rounded-[40px] flex gap-1 items-center">
                <div className="flex items-center gap-2">
                  <img src={home_white} alt="home1" />
                  <img src={ar_white} alt="ar" />
                </div>
                <div>
                  <p className="text-[1rem] font-normal text-white whitespace-nowrap">
                    Liên hệ
                  </p>
                </div>
              </div>
              <div className="w-full flex flex-col gap-1">
                <p className="text-[28px] font-semibold text-white">
                  LIÊN HỆ VỚI CHÚNG TÔI
                </p>
                <p className="text-white text-[16px] font-normal">
                  Chúng tôi luôn sẵn sàng giải đáp mọi thắc mắc của bạn, lắng
                  nghe ý kiến và hỗ trợ bạn từng bước trong hành trình chuyển
                  đổi số. Đội ngũ Blue Rise cam kết đồng hành và mang đến cho
                  bạn những giải pháp phù hợp nhất
                </p>
              </div>
            </div>
          </div>
        </div>
        <div
          className="hidden md:block w-full relative h-[20rem] mt-1 bg-cover bg-no-repeat bg-center"
          style={{
            backgroundImage: `url(${ct_mobi})`,
          }}
        >
          <div className="w-full mx-auto h-[20rem]">
            <div className=" flex flex-col gap-2 items-center justify-center w-full mx-auto pt-20">
              <div className="w-full h-[2.625rem] rounded-[40px] flex items-center justify-center ">
                <div className="flex items-center gap-2">
                  <img src={home_white} alt="home1" />
                  <img src={ar_white} alt="ar" />
                </div>
                <div>
                  <p className="text-[1rem] font-normal text-white whitespace-nowrap">
                    Liên hệ
                  </p>
                </div>
              </div>
              <div className="w-full text-center px-5">
                <p className="text-[32px] font-semibold text-white">
                  LIÊN HỆ VỚI CHÚNG TÔI
                </p>
                <p className="text-white text-[18px] font-normal">
                  Chúng tôi luôn sẵn sàng giải đáp mọi thắc mắc của bạn, lắng
                  nghe ý kiến và hỗ trợ bạn từng bước trong hành trình chuyển
                  đổi số.
                </p>
                <p className="text-white text-[18px] font-normal">
                  Đội ngũ Blue Rise cam kết đồng hành và mang đến cho bạn những
                  giải pháp phù hợp nhất
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
